<template>
	<div>
		<pagesHeading/>
		<div class="container py-5" :class="{ 'loading-app-style': loading }">
			<div v-if="loading" style="display: flex; align-items: center; justify-content: center">
				<div class="loader"></div>
			</div>
			<div v-else class="row mt-2">
				<div v-for="(category, index) in categories" :key="index" class="col-md-4 col-sm-6 col-12">
					<router-link :to="{name: 'categories-view', params: {slug: category.slug} }" class="no-decoration text-white">
						<!-- :style="{ backgroundImage: `url(${category.image})` }" -->
						<!-- -->
						<div class="card mx-auto c2 my-3 block bounceIn animated"
							:style="{ background: `linear-gradient(#fcad4d9c, #000000b0), url(${category.image})` }">
							<div class="card-body h-40 c2-body d-flex flex-column">
								<h3 class="card-title text-center text-white font-weight-bold"> {{ category.name }}</h3>
								<div class="text-center mt-auto">
									<router-link class="read-more read-more-1" :to="{name: 'categories-view', params: {slug:category.slug} }">
										<button>{{$t('common.read-more')}}</button>
									</router-link>
								</div>
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import pagesHeading from '../components/PagesHeading.vue'
import { mapActions, mapState } from 'vuex';
export default {
	components: {
		pagesHeading
	},
	data() {
		return {
			loading: true
		}
	},
	computed: {
		...mapState({
			categories: state => state.categories.categories
		})
	},
	methods: {
		...mapActions('categories', ['fetchCategories']),
		fetch() {
			if (!this.categories[0]) {
				this.fetchCategories()
					.finally(() => { this.loading = false });
			} else {
				this.loading = false
			}
		}
	},
	created() {
		this.fetch();
	}
}
</script>
<style scoped>
body {
	background-color: #fff;
}

.card {
	background-size: 110% auto !important;
	height: 200px !important;
	border-radius: 18px !important;
	border: 0px !important;
	box-shadow: -1px 2px 10px rgba(0, 0, 0, 0.25) !important;
	transition: all 0.5s ease, background-size 0.5s ease;
}

.card:hover {
	background-size: 117.5% auto !important;
	box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}

.read-more button {
	border: 1px solid #fff;
	color: #fff;
	border-radius: 30px;
	padding: 4px 20px;
	background-color: transparent;
}

.read-more button:hover {
	background-color: #fff;
	color: #FCAD4D;
}

.card-body h3 {
	margin-top: 3vh;
}

h3.card-title {
	box-shadow: none;
	padding-bottom: 0;
}

</style>